"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = FeaturesVerticalTabItem;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _image = require("@site/pattern-library-core/image");
var _react2 = require("@linaria/react");
var _patternLibraryUtils = require("@site/pattern-library-utils");
const StyledLazyPicture = /*#__PURE__*/(0, _react2.styled)(_image.LazyPicture)({
  name: "StyledLazyPicture",
  class: "pl-s1yoyuls"
});

/**
 * FeaturesVerticalTabItem component.
 *
 * @param {object} props React props
 * @param {object} props.tablet Tablet Image url and alt text
 * @param {object} props.mobile Mobile Image url and alt text
 * @param {object} props.desktop Desktop Url and Alt text
 * @returns {React.ReactElement} FeaturesVerticalTabItem component
 * @public
 */

function FeaturesVerticalTabItem({
  tablet = {},
  mobile = {},
  desktop = {}
}) {
  return /*#__PURE__*/_react.default.createElement(StyledLazyPicture, {
    defaultSrc: desktop.url,
    defaultAltText: desktop.altText,
    dataCy: "features-vertical-tab-item",
    threshold: 0
  }, /*#__PURE__*/_react.default.createElement("source", {
    srcSet: mobile.url,
    media: `${_patternLibraryUtils.deviceMax.mobileLg}`
  }), /*#__PURE__*/_react.default.createElement("source", {
    srcSet: tablet.url,
    media: `${_patternLibraryUtils.deviceMax.tablet}`
  }), /*#__PURE__*/_react.default.createElement("source", {
    srcSet: desktop.url,
    media: `${_patternLibraryUtils.device.tabletLg}`
  }));
}
FeaturesVerticalTabItem.propTypes = {
  tablet: _propTypes.default.shape(_image.imgPropShape),
  mobile: _propTypes.default.shape(_image.imgPropShape),
  desktop: _propTypes.default.shape(_image.imgPropShape).isRequired
};